import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock, Sparkles } from "lucide-react";

// Inline upgrade strip for composers. Drop it above or inside any form that
// would 402 for users without an active subscription. Returns null for anyone
// with full access (trial / paid / complimentary / admin) so gated pages don't
// need their own conditional wrappers.
//
// v77.99.8 — distinguishes the read-only grace period ("you can subscribe to
// add new entries again") from a fully locked account ("subscribe to regain
// access — your data is safe and on file"). The CTA label changes to match.
export const UpgradePrompt = ({ feature, testid }) => {
  const { user } = useAuth();
  const plan = user?.plan;
  if (!plan || plan.has_full_access) return null;

  const isLocked = plan.plan === "locked" || plan.is_locked;
  const heading = isLocked ? "Your account is locked" : "Read-only grace period";
  const ctaLabel = isLocked ? "Reactivate" : "Subscribe";
  const detail = isLocked
    ? "Your trial and grace period have ended. Subscribe to regain full access — your data is safe and on file."
    : "Your trial has ended — you can still view records and export, but new entries are paused until you subscribe.";

  return (
    <div
      className="bg-[#FDF4E2] border border-[#E6CFA2] text-[#8F6B1F] rounded-sm px-4 py-3 flex items-start gap-3"
      role="alert"
      data-testid={testid || "upgrade-prompt"}
    >
      <Lock className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={1.75} />
      <div className="min-w-0 flex-1 text-sm">
        <div className="font-medium">{heading}</div>
        <div className="text-[#8F6B1F]/90 mt-0.5">
          {feature ? `Subscribe to ${feature}. ` : ""}
          {detail}
        </div>
      </div>
      <Link
        to="/app/upgrade"
        className="flex-shrink-0 inline-flex items-center gap-1.5 text-xs font-medium text-white bg-[#1F9FA4] hover:bg-[#198185] rounded-sm px-3 py-1.5"
        data-testid={`${testid || "upgrade-prompt"}-cta`}
      >
        <Sparkles className="w-3.5 h-3.5" /> {ctaLabel}
      </Link>
    </div>
  );
};
